import { sendGet } from 'api/axios';
import { useQuery } from 'react-query';

interface IParams {
  per_page: number;
  page: number;
}

const useGetListGroupJoin = (params?: IParams) =>
  useQuery(
    ['list group join user', params],
    async () => {
      const res = await sendGet(`/group/list/joining`, params);
      return res;
    },
    {
      staleTime: Infinity,
      cacheTime: 7200000,
    }
  );

export default useGetListGroupJoin;
